<template>
    <div class="paginator-container" v-if="paginator">
        <nav aria-label="Paginator" v-if="isPaginable">
            <ul class="pagination mb-0">

                <li class="page-item" :class="{ disabled: isFirstPage }">
                    <a class="page-link" href="#" aria-label="Previous" @click.prevent="firstPage()">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>

                <li class="page-item"
                    v-if="(page >= (paginator.current_page - 3) && page <= (paginator.current_page + 3))"
                    v-for="page in paginator.last_page"
                    :class="{ active: (page == paginator.current_page) }">
                    <a class="page-link" href="#" @click.prevent="moveTo(page)">
                        <i v-if="moving == page" class="fa fa-spin fa-spinner"></i>
                        <span v-if="moving != page" v-text="page"></span>
                    </a>
                </li>

                <li class="page-item" :class="{ disabled: isLastPage }">
                    <a class="page-link" href="#" aria-label="Next" @click.prevent="lastPage()">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>

            </ul>
        </nav>

        <div class="text-muted">
            Showing {{ paginator.data.length }} <span v-if="isPaginable">of {{ paginator.total }}</span> <span v-text="pluralize('result', paginator.data.total)"></span>.
        </div>
    </div>
</template>
<script>
export default {

    props:{
        paginator:{
            required: true,
        },
    },

    data(){
        return {
            moving: false,
        }
    },

    methods:{

        moveTo(page){
            this.moving = page;
            if(page != this.paginator.current_page) {
                this.$emit('change', page)
                this.updateUrlHistory(page)
            }
        },

        firstPage() {
            this.moveTo(1)
        },

        lastPage() {
            this.moveTo(this.paginator.last_page)
        },

        updateUrlHistory(page){
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('page', page)
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        }
    },

    watch:{
        paginator(){
            this.moving = false;
        }
    },

    computed:{
        isPaginable(){
            return !!this.paginator && (this.paginator.last_page > 1);
        },

        isFirstPage(){
            return !!this.paginator && (this.paginator.current_page == 1);
        },

        isLastPage(){
            return !!this.paginator && (this.paginator.last_page == this.paginator.current_page)
        },
    },

}
</script>
